// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__mXrY2","row":"styles_row__2uTl2"};